import { create } from 'zustand'

interface NoBarcodeConfirmStore {
  /** The completion waiting on the team member's answer; null while the modal is closed. */
  pendingCompletion: (() => void) | null
  /** Open the modal; `proceed` runs only if the team member confirms. */
  request: (proceed: () => void) => void
  /** Close the modal and run the pending completion. */
  confirm: () => void
  /** Close the modal without completing; the order stays in its current state. */
  dismiss: () => void
}

export const useNoBarcodeConfirmStore = create<NoBarcodeConfirmStore>()((set, get) => ({
  pendingCompletion: null,

  request: proceed => set({ pendingCompletion: proceed }),

  confirm: () => {
    const proceed = get().pendingCompletion
    set({ pendingCompletion: null })
    proceed?.()
  },

  dismiss: () => set({ pendingCompletion: null }),
}))
